module.exports = __webpack_public_path__ + "static/home-apartment-ef534c67e5b8979402936201819f1a03.png";